'use strict';

var CPartyData = {};

CPartyData.config = {
    1: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 4,
        "availableBlocks": [
            "maze_step_move_step"
        ],
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_1,
            "image": 1
        }
    },
    2: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 4,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_jump"
        ],
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_2,
            "image": 2
        }
    },
    3: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate"
        ],
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_3,
            "image": 3
        }
    },
    4: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump"
        ],
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_4,
            "image": 4
        }
    },
    5: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 7,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump"
        ],
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_5,
            "image": 5
        }
    },
    6: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 3,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_\\w*for"
            ]
        },
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_6,
            "image": 6
        }
    },
    7: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 4,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_\\w*for"
            ]
        },
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_7,
            "image": 7
        }
    },
    8: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 5,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_for",
            ]
        },
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_8,
            "image": 8
        }
    },
    9: {
        "gridSize": {
            width: 7,
            height: 6
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 7,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_\\w*for"
            ]
        },
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_9,
            "image": 9
        }
    },
    10: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "bitmapPath": "/img/assets/ntry/bitmap/maze1/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "maze_step_move_step",
            "maze_step_rotate",
            "maze_step_jump",
            "maze_step_for"
        ],
        "essentialBlockInfo": {
            matchCnt: 1,
            blocks: [
                "maze_step_\\w*for"
            ]
        },
        "playerType" : 'Cparty_robot',
        "intro": {
            "content": Lang.Menus.cparty_robot_intro_10,
            "image": 10
        }
    },
    11: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "limitBlockCnt": 3,
        "blockMenuAlign": 'LEFT',
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ]
        ],
        "intro": {
            "content": Lang.Menus.cparty_car_intro_1,
            "image" :11
        }
    },
    12: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "limitBlockCnt": 8,
        "blockMenuAlign": 'LEFT',
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ]
        ],
        "intro": {
            "content": Lang.Menus.cparty_car_intro_2,
            "image" : 12
        }
    },
    13: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "limitBlockCnt": 3,
        "blockMenuAlign": 'LEFT',
         "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_go_slow"}
            ]
        ],
        "intro": {
            "content": Lang.Menus.cparty_car_intro_3,
            "image" : 13
        }
    },
    14: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "blockMenuAlign": 'LEFT',
        "limitBlockCnt": 2,
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ]
        ],
        "intro": {
            "content": Lang.Menus.cparty_car_intro_4,
            "image" : 14
        },
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest"
            ]
        }
    },
    15: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "blockMenuAlign": 'LEFT',
        "limitBlockCnt": 6,
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest"
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_5,
            "image" : 15
        }
    },
    16: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "blockMenuAlign": 'LEFT',
        "limitBlockCnt": 4,
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ],
            [
                {type: "jr_if_construction"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest",
                "jr_if_construction",
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_6,
            "image" : 16
        }
    },
    17: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "limitBlockCnt": 4,
        "blockMenuAlign": 'LEFT',
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ],
            [
                {type: "jr_if_construction"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest",
                "jr_if_construction"
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_7,
            "image" : 17
        }
    },
    18: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "limitBlockCnt": 4,
        "blockMenuAlign": 'LEFT',
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_go_slow"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ],
            [
                {type: "jr_if_speed"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest",
                "jr_if_speed"
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_8,
            "image" : 18
        }
    },
    19: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "blockMenuAlign": 'LEFT',
        "limitBlockCnt": 6,
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_go_slow"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ],
            [
                {type: "jr_if_construction"}
            ],
            [
                {type: "jr_if_speed"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest",
                "jr_if_construction",
                "jr_if_speed"
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_9,
            "image" : 19
        }
    },
    20: {
        "gridSize": {
            width: 7,
            height: 5
        },
        "tileSize": 68,
        "playerType": "CpartyCar",
        "bitmapPath": "/img/assets/ntry/bitmap/maze_car/",
        "blockMenuAlign": 'LEFT',
        "limitBlockCnt": 7,
        "availableCode": [
            [
                {type: "jr_go_straight"}
            ],
            [
                {type: "jr_turn_left"}
            ],
            [
                {type: "jr_turn_right"}
            ],
            [
                {type: "jr_go_slow"}
            ],
            [
                {type: "jr_repeat_until_dest"}
            ],
            [
                {type: "jr_if_construction"}
            ],
            [
                {type: "jr_if_speed"}
            ]
        ],
        "essentialBlockInfo": {
            blocks: [
                "jr_repeat_until_dest",
                "jr_if_construction",
                "jr_if_speed"
            ]
        },
        "intro": {
            "content": Lang.Menus.cparty_car_intro_10,
            "image" : 20
        }
    },
    21: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down"
        ],
        "essentialBlockInfo": {
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "돌을 피해 오른쪽 행성까지 안전하게 이동할 수 있도록 도와주세요.",
                "detail": "돌을 피해 오른쪽 행성까지 안전하게 이동할 수 있도록 도와주세요.",
                "image": "21-map"
            },
            {
                "title": "시작 방법",
                "content": "어떻게 시작할 수 있나요?",
                "detail": "1. 블록 꾸러미에서 원하는 블록을 꺼내어 “시작하기를 클릭했을 때” 블록과 연결해봐<br>2. 다 조립했으면, 시작을 눌러봐<br>3. 나는 네가 조립한 블록대로 위에서부터 순서대로 움직일게",
                "image": 21
            },
            {
                "title": "움직이게 하기",
                "content": "엔트리봇은 어떻게 움직이나요?",
                "detail": "나는 위쪽으로 가거나 앞으로 가거나 아래쪽으로 갈 수 있어.<br>방향을 정할 때에는 돌이 없는 방향으로 안전하게 갈 수 있도록 해줘.<br>나를 화면 밖으로 내보내면 우주미아가 되어버리니 조심해!",
                "image": 22
            }
        ],
        "intro": {
            "content": "안녕? 나는 엔트리봇이라고 해. 우주 탐사를 마치고 지구로 돌아가려는데 우주를 떠다니는 돌들 때문에 쉽지 않네. 내가 안전하게 집에 갈 수 있도록 도와줄래? 나의 우주선에는 나의 앞과 위, 아래에 무엇이 어느 정도의 거리에 있는지 알려주는 레이더가 있어 너의 판단을 도와줄 거야!"
        }
    },
    22: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 8,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down"
        ],
        "essentialBlockInfo": {
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "돌을 피해 오른쪽 행성까지 안전하게 이동할 수 있도록 도와주세요.",
                "detail": "돌을 피해 오른쪽 행성까지 안전하게 이동할 수 있도록 도와주세요.",
                "image": "22-map"
            },
            {
                "title": "움직이게 하기",
                "content": "엔트리봇은 어떻게 움직이나요?",
                "detail": "나는 위쪽으로 가거나 앞으로 가거나 아래쪽으로 갈 수 있어.<br>방향을 정할 때에는 돌이 없는 방향으로 안전하게 갈 수 있도록 해줘.<br>나를 화면 밖으로 내보내면 우주미아가 되어버리니 조심해!",
                "image": 22
            },
            {
                "title": "시작 방법",
                "content": "어떻게 시작할 수 있나요?",
                "detail": "1. 블록 꾸러미에서 원하는 블록을 꺼내어 “시작하기를 클릭했을 때” 블록과 연결해봐<br>2. 다 조립했으면, 시작을 눌러봐<br>3. 나는 네가 조립한 블록대로 위에서부터 순서대로 움직일게",
                "image": 21
            }
        ],
        "intro": {
            "content": "고마워! 덕분에 돌을 쉽게 피할 수 있었어. 그런데 이번엔 더 많은 돌이 있잖아? 블록들을 조립하여 돌들을 이리저리 잘 피해 보자!"
        }
    },
    23: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                'ai_repeat_until_reach'
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "반복하기 블록으로 돌들을 피할 수 있도록 도와주세요.",
                "detail": "반복하기 블록으로 돌들을 피할 수 있도록 도와주세요.",
                "image": "23-map"
            },
            {
                "title": "반복 블록",
                "content": "반복 블록은 무슨 블록인가요?",
                "detail": "휴~ 이번에 가야 할 길은 너무 멀어서 하나씩 조립하기는 힘들겠는걸? 반복하기블록을 사용해봐.<br>똑같이 반복되는 블록들을 반복하기 블록으로 묶어주면 아주 긴 블록을 짧게 줄여줄 수 있어!",
                "image": 23
            },
            {
                "title": "움직이게 하기",
                "content": "엔트리봇은 어떻게 움직이나요?",
                "detail": "나는 위쪽으로 가거나 앞으로 가거나 아래쪽으로 갈 수 있어.<br>방향을 정할 때에는 돌이 없는 방향으로 안전하게 갈 수 있도록 해줘.<br>나를 화면 밖으로 내보내면 우주미아가 되어버리니 조심해!",
                "image": 22
            },
            {
                "title": "시작 방법",
                "content": "어떻게 시작할 수 있나요?",
                "detail": "1. 블록 꾸러미에서 원하는 블록을 꺼내어 “시작하기를 클릭했을 때” 블록과 연결해봐<br>2. 다 조립했으면, 시작을 눌러봐<br>3. 나는 네가 조립한 블록대로 위에서부터 순서대로 움직일게",
                "image": 21
            }
        ],
        "intro": {
            "content": "좋았어! 안전하게 돌을 피했어. 그런데 앞을 봐! 아까보다 더 많은 돌이 있어. 하지만 걱정하지 마. 나에게 반복하기 블록이 있거든. 반복하기 블록 안에 움직이는 블록을 넣으면 목적지에 도착할 때까지 계속 움직일게!"
        }

    },
    24: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 5,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_if_else_1"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_if_else_1",
                "ai_repeat_until_reach_un "
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "만약 블록으로 돌을 피할 수 있도록 도와주세요.",
                "detail": "만약 블록으로 돌을 피할 수 있도록 도와주세요.",
                "image": "24-map"
            },
            {
                "title": "만약 블록(1)",
                "content": "만약 ~라면 블록은 어떻게 동작하나요?",
                "detail": "만약 앞에 ~가 있다면 / 아니면 블록을 사용하면 내 바로 앞에 돌이 있는지 없는지 확인해서 다르게 움직일 수 있어~<br>만약 내 바로 앞에 돌이 있다면 '만약' 아래에 있는 블록들을 실행하고 돌이 없으면 '아니면' 안에 있는 블록들을 실행할 거야.<br>내 바로 앞에 돌이 있을 때와 없을 때, 어떻게 움직일지 잘 결정해줘~",
                "image": 24
            },
            {
                "title": "반복 블록",
                "content": "반복 블록은 어떻게 사용하나요?",
                "detail": "휴~ 이번에 가야 할 길은 너무 멀어서 하나씩 조립하기는 힘들겠는걸?<br>반복하기블록을 사용해봐.<br>똑같이 반복되는 블록들을 반복하기 블록으로 묶어주면 아주 긴 블록을 짧게 줄여줄 수 있어!",
                "image": 23
            }
        ],
        "intro": {
            "content": "대단해! 반복하기 블록을 쓰니 많은 돌을 피하기가 훨씬 수월한걸! 하지만 이렇게 일일이 조종하기는 피곤하다. 나에겐 레이더가 있으니 앞으로 무엇이 나올지 알 수 있어. 앞으로 계속 가다가 앞에 돌이 있으면 피할 수 있도록 해줄래?"
        }

    },
    25: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 6,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_if_else_2",
            "ai_boolean_distance"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_repeat_until_reach_un",
                "ai_if_else_2_un"
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "레이더의 사용 방법을 익히고 돌을 피해보세요.",
                "detail": "레이더의 사용 방법을 익히고 돌을 피해보세요.",
                "image": "25-map"
            },
            {
                "title": "레이더(1)",
                "content": "레이더란 무엇인가요? 어떻게 활용할 수 있나요?",
                "detail": "레이더는 지금 내가 물체와 얼마나 떨어져 있는지 알려주는 기계야.<br>만약 바로 내 앞에 무엇인가 있다면 앞쪽 레이더는 '1'을 보여줘.<br>또, 레이더는 혼자 있을 때 보다 만약 &lt;사실&gt;이라면 / 아니면 블록과<br> 같이 쓰이면 아주 강력하게 쓸 수 있어.<br>예를 들어 내 앞에 물체와의 거리가 1보다 크다면 나는 안전하게 앞으로 갈 수 있겠지만, 아니라면 위나 아래쪽으로 피하도록 할 수 있지.",
                "image": 26
            },
            {
                "title": "만약 블록(2)",
                "content": "만약 <사실>이라면 블록은 어떻게 사용하나요?",
                "detail": "만약 &lt;사실&gt;이라면 / 아니면 블록은 &lt;사실&gt; 안에 있는 내용이 맞으면 '만약' 아래에 있는 블록을 실행하고, 아니면 '아니면' 아래에 있는 블록을 실행해.<br>어떤 상황에서 다르게 움직이고 싶은 지를 잘 생각해서 &lt;사실&gt; 안에 적절한 판단 조건을 만들어 넣어봐.<br>판단 조건을 만족해서 '만약' 아래에 있는 블록을 실행하고 나면 '아니면' 아래에 있는 블록들은 실행되지 않는다는 걸 기억해!",
                "image": 25
            },
            {
                "title": "반복 블록",
                "content": "반복 블록은 무슨 블록인가요?",
                "detail": "휴~ 이번에 가야 할 길은 너무 멀어서 하나씩 조립하기는 힘들겠는걸?<br>반복하기블록을 사용해봐.<br>똑같이 반복되는 블록들을 반복하기 블록으로 묶어주면 아주 긴 블록을 짧게 줄여줄 수 있어!",
                "image": 23
            }

        ],
        "intro": {
            "content": "잘했어! 여기까지 와서 아주 기뻐. 이번에는 레이더가 앞에 있는 물체까지의 거리를 말해줄 거야. 이 기능을 사용하여 돌을 피해 보자! 돌까지의 거리가 멀 때는 앞으로 계속 가다가, 거리가 가까워지면 피할 수 있도록 해줄래?"
        }

    },
    26: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 9,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_if_else_2",
            "ai_boolean_distance"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_repeat_until_reach_un",
                "ai_if_else_2_un"
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "레이더를 활용해 돌을 쉽게 피할 수 있도록 도와주세요.",
                "detail": "레이더를 활용해 돌을 쉽게 피할 수 있도록 도와주세요.",
                "image": "26-map"
            },
            {
                "title": "만약 블록(3)",
                "content": "만약 블록이 겹쳐져 있으면 어떻게 동작하나요?",
                "detail": "만약 ~ / 아니면 블록안에도 만약 ~ / 아니면 블록을 넣을 수 있어! 이렇게 되면 다양한 상황에서 내가 어떻게 행동해야 할지 정할 수 있어.<br>예를 들어 앞에 돌이 길을 막고 있을때와 없을때의 행동을 정한다음, 돌이 있을때의 상황에서도 상황에 따라 위쪽으로 갈지 아래쪽으로 갈지 선택 할 수 있어",
                "image": 27
            },
            {
                "title": "레이더(1)",
                "content": "레이더란 무엇인가요? 어떻게 활용할 수 있나요?",
                "detail": "레이더는 지금 내가 물체와 얼마나 떨어져 있는지 알려주는 기계야.<br>만약 바로 내 앞에 무엇인가 있다면 앞쪽 레이더는 '1'을 보여줘.<br>또, 레이더는 혼자 있을 때 보다 만약 &lt;사실&gt;이라면 / 아니면 블록과 같이 쓰이면 아주 강력하게 쓸 수 있어.<br>예를 들어 내 앞에 물체와의 거리가 1보다 크다면 나는 안전하게 앞으로 갈 수 있겠지만, 아니라면 위나 아래쪽으로 피하도록 할 수 있지.",
                "image": 26
            },
            {
                "title": "만약 블록(2)",
                "content": "만약 <사실>이라면 블록은 어떻게 사용하나요?",
                "detail": "만약 &lt;사실&gt;이라면 / 아니면 블록은 &lt;사실&gt; 안에 있는 내용이 맞으면 '만약' 아래에 있는 블록을 실행하고, 아니면 '아니면' 아래에 있는 블록을 실행해.<br>어떤 상황에서 다르게 움직이고 싶은 지를 잘 생각해서 &lt;사실&gt; 안에 적절한 판단 조건을 만들어 넣어봐.<br>판단 조건을 만족해서 '만약' 아래에 있는 블록을 실행하고 나면 '아니면' 아래에 있는 블록들은 실행되지 않는다는 걸 기억해!",
                "image": 25
            }
        ],
        "intro": {
            "content": "와~ 멋진걸? 레이더를 활용하여 돌을 잘 피해 나가고 있어! 이번에는 여러 개의 레이더를 사용하여 이리저리 돌들을 피해 나갈 수 있게 만들어줄래?"
        }
    },
    27: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 10,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_if_else_2",
            "ai_boolean_distance",
            "ai_distance_value"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_repeat_until_reach_un",
                "ai_if_else_2_un"
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "레이더를 활용해 돌을 쉽게 피할 수 있도록 도와주세요.",
                "detail": "레이더를 활용해 돌을 쉽게 피할 수 있도록 도와주세요.",
                "image": "27-map"
            },
            {
                "title": "레이더(2)",
                "content": "위쪽 레이더와 아래쪽 레이더의 값을 비교하고 싶을 땐 어떻게 하나요?",
                "detail": "([위쪽]레이더) 블록은 위쪽 물체까지의 거리를 뜻하는 블록이야.<br>아래쪽과 위쪽 중에서 어느 쪽에 돌이 더 멀리 있는지 확인하기 위해서 쓸 수 있는 블록이지.<br>돌을 피해가는 길을 선택할 때에는 돌이 멀리 떨어져 있는 쪽으로 피하는게 앞으로 멀리 가는데 유리할거야~",
                "image": 28
            },
            {
                "title": "만약 블록(3)",
                "content": "만약 블록이 겹쳐져 있으면 어떻게 동작하나요?",
                "detail": "만약 ~ / 아니면 블록안에도 만약 ~ / 아니면 블록을 넣을 수 있어! 이렇게 되면 다양한 상황에서 내가 어떻게 행동해야 할지 정할 수 있어.<br>예를 들어 앞에 돌이 길을 막고 있을때와 없을때의 행동을 정한다음, 돌이 있을때의 상황에서도 상황에 따라 위쪽으로 갈지 아래쪽으로 갈지 선택 할 수 있어",
                "image": 27
            },
            {
                "title": "레이더(1)",
                "content": "레이더란 무엇인가요? 어떻게 활용할 수 있나요?",
                "detail": "레이더는 지금 내가 물체와 얼마나 떨어져 있는지 알려주는 기계야.<br>만약 바로 내 앞에 무엇인가 있다면 앞쪽 레이더는 '1'을 보여줘.<br>또, 레이더는 혼자 있을 때 보다 만약 &lt;사실&gt;이라면 / 아니면 블록과<br> 같이 쓰이면 아주 강력하게 쓸 수 있어.<br>예를 들어 내 앞에 물체와의 거리가 1보다 크다면 나는 안전하게 앞으로 갈 수 있겠지만, 아니라면 위나 아래쪽으로 피하도록 할 수 있지.",
                "image": 26
            },
            {
                "title": "만약 블록(2)",
                "content": "새로운 만약 블록은 어떻게 사용하나요?",
                "detail": "만약 &lt;사실&gt;이라면 / 아니면 블록은 &lt;사실&gt; 안에 있는 내용이 맞으면 '만약' 아래에 있는 블록을 실행하고, 아니면 '아니면' 아래에 있는 블록을 실행해.<br>어떤 상황에서 다르게 움직이고 싶은 지를 잘 생각해서 &lt;사실&gt; 안에 적절한 판단 조건을 만들어 넣어봐.<br>판단 조건을 만족해서 '만약' 아래에 있는 블록을 실행하고 나면 '아니면' 아래에 있는 블록들은 실행되지 않는다는 걸 기억해!",
                "image": 25
            }
        ],
        "intro": {
            "content": "휴~ 지구에 점점 가까워지고 있어! 돌을 피할 때 기왕이면 더 안전한 길로 가고 싶어! 아마도 돌이 더 멀리 있는 쪽이 더 안전한 길이겠지? 위쪽 레이더와 아래쪽 레이더를 비교하여 더 안전한 쪽으로 움직이도록 해줄래?"
        }

    },
    28: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 12,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_if_else_2",
            "ai_boolean_object"
        ],
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_repeat_until_reach_un",
                "ai_if_else_2_un"
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "아이템을 향해 이동하여 돌을 피해보세요.",
                "detail": "아이템을 향해 이동하여 돌을 피해보세요.",
                "image": "28-map"
            },
            {
                "title": "물체 이름 확인",
                "content": "앞으로 만날 물체의 이름을 확인해서 무엇을 할 수 있나요?",
                "detail": "아이템을 얻기위해서는 아이템이 어디에 있는지 확인할 필요가 있어. <br>그럴 때 사용할 수 있는 블록이 [위쪽] 물체는 [아이템]인가? 블록이야.<br>이 블록을 활용하면 아이템이 어느 위치에 있는지 알 수 있고 아이템이 있는 방향으로 움직이도록 블록을 조립할 수 있어.",
                "image": 29
            },
            {
                "title": "만약 블록(3)",
                "content": "만약 블록이 겹쳐져 있을 수도 있나요?",
                "detail": "만약 ~ / 아니면 블록안에도 만약 ~ / 아니면 블록을 넣을 수 있어! 이렇게 되면 다양한 상황에서 내가 어떻게 행동해야 할지 정할 수 있어.<br>예를 들어 앞에 돌이 길을 막고 있을때와 없을때의 행동을 정한다음 돌이 있을때의 상황에서도 상황에 따라 위쪽으로 갈지 아래쪽으로 갈지 선택 할 수 있어",
                "image": 27
            }
        ],
        "intro": {
            "content": "좋아! 덕분에 무사히 비행하고 있어. 어? 그런데 저게 뭐지? 저건 내가 아주 위급한 상황에서 사용할 수 있는 특별한 에너지야! 이번에는 저 아이템들을 모두 모으며 움직이자!"
        }

    },
    29: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 16,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_use_item",
            "ai_if_else_2",
            "ai_boolean_object"
        ],
        "maxItem": 3,
        "essentialBlockInfo": {
            matchCnt : 1,
            blocks : [
                "ai_repeat_until_reach_un",
                "ai_if_else_2_un"
            ]
        },
        "hints": [
            {
                "title": "게임의 목표",
                "content": "아이템을 적절하게 사용해서 돌을 피해보세요.",
                "detail": "아이템을 적절하게 사용해서 돌을 피해보세요.",
                "image": "29-map"
            },
            {
                "title": "아이템",
                "content": "아이템은 어떻게 얻고 사용하나요?",
                "detail": "돌들을 이리저리 잘 피해 나가더라도 앞이 모두 돌들로 꽉 막혀있을 땐 빠져나갈 방법이 없겠지? 그럴 때에는 아이템사용 블럭을 사용해봐. <br>이 블록은 내 앞의 돌들을 모두 없애는 블록이야.<br>단, 아이템이 있어야지만 블록을 사용할 수 있고, 아이템은 이미지를 지나면 얻을 수 있어.",
                "image": 30
            },
            {
                "title": "물체 이름 확인",
                "content": "앞으로 만날 물체의 이름을 확인해서 무엇을 할 수 있나요?",
                "detail": "아이템을 얻기위해서는 아이템이 어디에 있는지 확인할 필요가 있어. <br>그럴 때 사용할 수 있는 블록이 [위쪽] 물체는 [아이템]인가? 블록이야.<br>이 블록을 활용하면 아이템이 어느 위치에 있는지 알 수 있고 아이템이 있는 방향으로 움직이도록 블록을 조립할 수 있어.",
                "image": 29
            }
        ],
        "intro": {
            "content": "훌륭해! 이제 지구까지 얼마 안 남았어. 그런데 앞을 보니 돌들로 길이 꽉 막혀서 지나갈 수가 없잖아? 하지만 걱정하지 마. 아이템을 획득해서 사용하면 앞에 있는 꽉 막힌 돌들을 없앨 수 있다고!"
        }

    },
    30: {
        "gridSize": {
            width: 5,
            height: 3
        },
        "tileSize": 100,
        "bitmapPath": "/img/assets/ntry/bitmap/ai/",
        "limitBlockCnt": 32,
        "availableBlocks": [
            "ai_move_right",
            "ai_move_up",
            "ai_move_down",
            "ai_use_item",
            "ai_repeat_until_reach",
            "ai_if_else_1",
            "ai_if_else_2",
            "ai_boolean_distance",
            "ai_boolean_object",
            "ai_boolean_and",
            "ai_distance_value"
        ],
        "maxItem": 3,
        "mapper": true,
        "hints": [
            {
                "title": "게임의 목표",
                "content": "지금까지 배운 것들을 모두 활용해서 최대한 멀리 가보세요.",
                "detail": "지금까지 배운 것들을 모두 활용해서 최대한 멀리 가보세요.",
                "image": "30-map"
            },
            {
                "title": "그리고",
                "content": "그리고 블록은 어떻게 사용하나요?",
                "detail": "그리고 블록에는 여러개의 조건을 넣을 수 있어, 넣은 모든 조건이 사실일때만 사실이 되어 만약 블록 안에 있는 블록이 실행되고, 하나라도 거짓이 있으면 거짓으로 인식해서 그 안에 있는 블록을 실행하지 않아",
                "image": 31
            }
        ],
        "intro": {
            "content": "좋아! 드디어 저기 지구가 보여! 이럴 수가! 이제는 날아오는 돌들을 미리 볼 수가 없잖아? 돌들이 어떻게 날아올지 알지 못해도 지금까지처럼만 움직이면 잘 피할 수 있을 것 같아! 지구까지 가보는 거야!"
        }
    }
}

/*
 * Generate tile entities. wall and road only.
 */
CPartyData.tileMap = {
    1: [
        ["wall_01", "wall_01", "wall_01", "wall_02", "wall_03", "wall_04", "wall_09"],
        ["wall_01", "wall_01", "wall_01", "wall_07", "wall_07", "wall_07", "wall_07"],
        ["wall_01", "wall_01", "wall_01", "road_01", "road_02", "road_02", "road_03"],
        ["wall_01", "wall_01", "wall_01", "wall_07_2", "wall_07_2", "wall_07_2", "wall_07_2"],
        ["wall_01", "wall_01", "wall_01", "wall_11_2", "wall_16", "wall_16", "wall_16"]
    ],
    2: [
        ["wall_01","wall_07","wall_07","wall_obstacle_01","wall_07","wall_obstacle_01","wall_07"],
        ["wall_01","road_03","road_03","road_03","road_03","road_03","road_03"],
        ["wall_01","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2"],
        ["wall_01","wall_01","wall_13","wall_13","wall_08_4","wall_01","wall_01"],
        ["wall_01","wall_11_2","wall_14","wall_14","wall_01","wall_01","wall_01"]
    ],
    3: [
        ["wall_01","wall_08_1","wall_07","wall_07","wall_09","wall_09","wall_12"],
        ["wall_01","wall_07","road_05","road_02","wall_01","wall_01","wall_01"],
        ["wall_01","road_01","road_03","wall_07_2","wall_01","wall_01","wall_01"],
        ["wall_01","wall_07_2","wall_07_2","wall_13","wall_01","wall_01","wall_01"],
        ["wall_01","wall_11_1","wall_12","wall_14","wall_01","wall_01","wall_01"]
    ],
    4: [
        ["wall_13","wall_13","wall_01","wall_01","wall_01","wall_13","wall_13"],
        ["wall_14","wall_14","wall_01","wall_obstacle_01","wall_01","wall_14","wall_14"],
        ["wall_12","wall_07_4","road4_L","road_02","road4_R","wall_07_3","wall_12"],
        ["wall_12","wall_07_4","road4_02","wall_15","road4_01","wall_07_3","wall_12"],
        ["wall_01","wall_01","wall_01","wall_08_4","wall_01","wall_01","wall_01"]
    ],
    5: [
        ["wall_01","wall_01","wall_01","wall_01","wall_07","wall_07","wall_01"],
        ["wall_01","wall_12","wall_12","wall_01","road_05","road_02","wall_01"],
        ["wall_01","wall_07","wall_07","wall_obstacle_01","road_02","wall_obstacle_03","wall_01"],
        ["wall_01","road_02","road_02","road_02","road_03","wall_13","wall_01"],
        ["wall_01","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_14","wall_01"]
    ],
    6: [
       ["wall_16","wall_02","wall_03","wall_03","wall_03","wall_04","wall_16"],
       ["wall_12","wall_12","wall_12","wall_12","wall_12","wall_12","wall_12"],
       ["road_02","road_02","road_02","road_02","road_02","road_02","road_02"],
       ["wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2"],
       ["wall_13","wall_13","wall_13","wall_13","wall_01","wall_01","wall_01"]
    ],
    7: [
        ["wall_01","wall_01","wall_01","wall_03","wall_03","wall_01","wall_16"],
        ["wall_07","wall_07","wall_obstacle_01","wall_07","wall_07","wall_obstacle_01","wall_07"],
        ["road_02","road_02","road_02","road_02","road_02","road_02","road_02"],
        ["wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2","wall_07_2"],
        ["wall_13","wall_13","wall_13","wall_13","wall_01","wall_01","wall_01"]
    ],
    8: [
        ["wall_01","wall_01","wall_01","wall_12","wall_01","wall_12","wall_03_2"],
        ["wall_01","wall_01","road_04","wall_12","road_04","wall_12","wall_03_2"],
        ["wall_01","wall_01","road_04","wall_12","road_04","wall_12","wall_02"],
        ["wall_01","wall_01","road_02","road_02","road_03","wall_12","wall_01"],
        ["wall_01","wall_01","wall_07_2","wall_07_2","wall_07_2","wall_12","wall_01"],
    ],
    9: [
        ["wall_01","wall_07","wall_07","wall_07","wall_07","wall_07","wall_03_2"],
        ["wall_01","road_05","road_05","road_05","road_05","road_05","wall_03_2"],
        ["wall_01","wall_07_2","wall_07_2","wall_07_2","wall_07_2","road_05","wall_04_2"],
        ["wall_01","wall_12","wall_12","wall_12","wall_12","road_05","wall_13"],
        ["wall_01","wall_07","wall_07","wall_07","wall_07","road_05","wall_14"],
        ["wall_01","road_05","road_05","road_05","road_05","road_05","wall_16"],
    ],
    10: [
        ["wall_01","wall_01","wall_01","wall_01","wall_01","wall_01","wall_15"],
        ["wall_01","wall_01","wall_01","wall_01","wall_07","wall_obstacle_01","road_06"],
        ["wall_01","wall_01","wall_07","wall_obstacle_01","road_06","road_12","road_03"],
        ["wall_07","wall_obstacle_01","road_06","road_12","road_03","wall_07_2","wall_07_2"],
        ["road_02","road_12","road_03","wall_07_2","wall_07_2","wall_12","wall_12"]
    ],
    11: [
        ["wall_01","wall_02","wall_03","wall_04","wall_01","wall_02","wall_01"],
        ["wall_04","wall_01","wall_01","wall_03","wall_02","wall_03","wall_02"],
        ["wall_03","road_02","road_02","road_02","road_02","wall_01","wall_04"],
        ["wall_02","wall_04","wall_03","wall_01","wall_03","wall_02","wall_03"],
        ["wall_01","wall_02","wall_04","wall_04","wall_01","wall_01","wall_04"]
    ],
    12: [
        ["wall_01","wall_02","wall_03","wall_04","wall_01","wall_02","wall_03"],
        ["wall_04","road_02","road_02","road_05","wall_03","wall_01","wall_02"],
        ["wall_02","wall_03","wall_01","road_01","wall_01","wall_04","wall_04"],
        ["wall_03","wall_04","wall_02","road_06","road_02","road_02","wall_01"],
        ["wall_04","wall_03","wall_01","wall_03","wall_02","wall_01","wall_02"]
    ],
    13: [
        ["wall_01","wall_02","wall_03","road_01","wall_04","wall_02","wall_03"],
        ["wall_02","wall_01","wall_04","road_01","wall_01","wall_02","wall_03"],
        ["wall_04","road_02","road_02","road_03","road_02","road_02","wall_04"],
        ["wall_03","wall_01","wall_02","road_01","wall_01","wall_03","wall_01"],
        ["wall_01","wall_02","wall_03","road_01","wall_03","wall_01","wall_04"]
    ],
    14: [
        ["wall_01","wall_02","wall_03","wall_04","wall_02","wall_03","wall_01"],
        ["wall_02","wall_03","wall_01","wall_02","wall_04","wall_02","wall_03"],
        ["road_02","road_02","road_02","road_02","road_02","road_02","road_02"],
        ["wall_03","wall_04","wall_02","wall_01","wall_03","wall_02","wall_01"],
        ["wall_01","wall_02","wall_04","wall_02","wall_01","wall_03","wall_04"]
    ],
    15: [
        ["wall_01","wall_02","wall_03","wall_01","wall_04","wall_02","wall_01"],
        ["wall_02","wall_01","wall_04","wall_02","road_04","road_02","road_02"],
        ["wall_01","wall_02","road_04","road_02","road_07","wall_01","wall_02"],
        ["road_04","road_02","road_07","wall_04","wall_01","wall_02","wall_03"],
        ["road_01","wall_04","wall_01","wall_02","wall_04","wall_01","wall_02"]
    ],
    16: [
        ["wall_04","wall_03","wall_02","wall_01","wall_05","wall_04","wall_03"],
        ["wall_01","wall_02","road_02","road_02","road_10","wall_01","wall_02"],
        ["wall_03","wall_01","wall_01","wall_03","road_01","wall_02","wall_01"],
        ["wall_01","wall_02","wall_04","wall_01","road_01","wall_01","wall_02"],
        ["road_02","road_02","road_02","road_02","road_11","wall_06","road_02"]
    ],
    17: [
        ["wall_05","wall_01","wall_04","wall_02","wall_03","wall_01","wall_02"],
        ["road_08","road_02","road_02","road_02","road_09","wall_06","road_02"],
        ["road_01","wall_04","wall_01","wall_03","road_01","wall_02","wall_01"],
        ["road_01","wall_04","wall_03","wall_01","road_01","wall_01","wall_03"],
        ["road_01","wall_01","wall_04","wall_03","wall_04","wall_03","wall_04"]
    ],
    18: [
        ["wall_01","wall_04","road_01","wall_02","wall_03","road_01","wall_02"],
        ["wall_02","wall_01","road_01","wall_01","wall_04","road_01","wall_04"],
        ["road_02","road_02","road_03","road_02","road_02","road_03","road_02"],
        ["wall_01","wall_02","road_01","wall_03","wall_03","road_01","wall_01"],
        ["wall_04","wall_03","road_01","wall_04","wall_04","road_01","wall_03"]
    ],
    19: [
        ["wall_01","road_01","wall_02","road_01","wall_04","road_01","wall_02"],
        ["wall_04","wall_05","wall_02","road_01","wall_02","road_01","wall_03"],
        ["road_02","road_03","road_02","road_03","road_02","road_03","wall_06"],
        ["wall_03","road_01","wall_02","road_01","wall_01","road_01","wall_02"],
        ["wall_01","road_01","wall_03","road_01","wall_04","road_01","wall_01"]
    ],
    20: [
        ["wall_01","wall_02","road_01","wall_04","road_01","wall_03","road_01"],
        ["wall_02","wall_04","road_01","wall_01","road_01","wall_02","wall_05"],
        ["road_02","wall_06","road_03","road_02","road_03","road_02","road_01"],
        ["wall_03","wall_01","road_01","wall_03","road_01","wall_01","road_01"],
        ["wall_01","wall_02","road_01","wall_01","road_01","wall_02","road_01"]
    ]
};

CPartyData.fence_behind = {
    1: [
        {image: "handrail_02", x: 3, y: 1},
        {image: "handrail_02", x: 4, y: 1},
        {image: "handrail_02", x: 5, y: 1},
        {image: "handrail_02", x: 6, y: 1}
    ],
    2: [
       {image: "handrail_10", x: 1, y: 0},
       {image: "handrail_10", x: 2, y: 0},
       {image: "handrail_10", x: 4, y: 0},
       {image: "handrail_10", x: 6, y: 0}
    ],
    3: [
        {image: "handrail_10", x:1, y:1},
        {image: "handrail_09", x:2, y:0},
        {image: "handrail_10", x:3, y:0}
    ],
    5: [
        {image: "handrail_10", x:1, y:2},
        {image: "handrail_10", x:2, y:2},
        {image: "handrail_01", x:4, y:0},
        {image: "handrail_02", x:5, y:0},
        {image: "handrail_13", x:4, y:1},

    ],
    6: [
        {image: "handrail_10", x:0, y:1},
        {image: "handrail_10", x:1, y:1},
        {image: "handrail_10", x:2, y:1},
        {image: "handrail_10", x:3, y:1},
        {image: "handrail_10", x:4, y:1},
        {image: "handrail_10", x:5, y:1},
        {image: "handrail_10", x:6, y:1}
    ],
    7: [
        {image: "handrail_02", x:0, y:1},
        {image: "handrail_02", x:1, y:1},
        {image: "handrail_02", x:3, y:1},
        {image: "handrail_02", x:4, y:1},
        {image: "handrail_02", x:6, y:1},
    ],
    8: [
        {image: "handrail_12", x:3, y:1},
        {image: "handrail_11", x:3, y:1},
        {image: "handrail_03", x:3, y:2}
    ],
    9: [
        {image: "handrail_10", x:1, y:0},
        {image: "handrail_10", x:3, y:0},
        {image: "handrail_10", x:4, y:0},
        {image: "handrail_10", x:2, y:0},
        {image: "handrail_10", x:3, y:0},
        {image: "handrail_10", x:1, y:4},
        {image: "handrail_10", x:2, y:4},
        {image: "handrail_10", x:3, y:4},
        {image: "handrail_10", x:4, y:4},
        {image: "handrail_10", x:5, y:0},
        {image: "handrail_16", x:5, y:4},
        {image: "handrail_15", x:5, y:3},
        {image: "handrail_15", x:5, y:2},
        {image: "handrail_14", x:5, y:1}
    ]
}

CPartyData.fence_front = {
    1: [
        {image: "handrail_02", x: 3, y: 2},
        {image: "handrail_02", x: 4, y: 2},
        {image: "handrail_02", x: 5, y: 2},
        {image: "handrail_02", x: 6, y: 2}
    ],

    2: [
        {image: "handrail_02", x: 1, y: 1},
        {image: "handrail_02", x: 2, y: 1},
        {image: "handrail_02", x: 3, y: 1},
        {image: "handrail_02", x: 4, y: 1},
        {image: "handrail_02", x: 5, y: 1},
        {image: "handrail_02", x: 6, y: 1}
    ],

    3: [
        {image: "handrail_02", x:1, y:2},
        {image: "handrail_06", x:2, y:2},
        {image: "handrail_04", x:2, y:1},
        {image: "handrail_02", x:3, y:1}
    ],
    4: [
        {image: "handrail_02", x:3, y:2},
        {image: "handrail_11", x:2, y:3},
        {image: "handrail_12", x:4, y:3},
        {image: "handrail_13", x:2, y:2},
        {image: "handrail_14", x:4, y:2}

    ],
    5: [
        {image: "handrail_02", x:1, y:3},
        {image: "handrail_02", x:2, y:3},
        {image: "handrail_06", x:4, y:3},
        {image: "handrail_02", x:3, y:3},
        {image: "handrail_02", x:5, y:1},
        {image: "handrail_15", x:4, y:2},
        {image: "handrail_15", x:4, y:1},
        {image: "handrail_11", x:4, y:2},
    ],
    6: [
        {image: "handrail_02", x:0, y:2},
        {image: "handrail_02", x:1, y:2},
        {image: "handrail_02", x:2, y:2},
        {image: "handrail_02", x:3, y:2},
        {image: "handrail_02", x:4, y:2},
        {image: "handrail_05", x:3, y:2},
        {image: "handrail_02", x:6, y:2},
    ],
    7: [
        {image: "handrail_02", x:0, y:2},
        {image: "handrail_02", x:1, y:2},
        {image: "handrail_02", x:2, y:2},
        {image: "handrail_02", x:3, y:2},
        {image: "handrail_02", x:4, y:2},
        {image: "handrail_02", x:5, y:2},
        {image: "handrail_02", x:6, y:2},
    ],
    8: [
        {image: "handrail_18", x:2, y: 3},
        {image: "handrail_02", x:3, y: 3},
        {image: "handrail_06", x:4, y: 3},
        {image: "handrail_11", x:4, y: 1},
        {image: "handrail_11", x:4, y: 2},
        {image: "handrail_12", x:2, y: 2},
        {image: "handrail_12", x:2, y: 1}
    ],
    9: [
        {image: "handrail_02", x:1, y:1},
        {image: "handrail_02", x:2, y:1},
        {image: "handrail_02", x:3, y:1},
        {image: "handrail_02", x:4, y:1},
        {image: "handrail_02", x:1, y:5},
        {image: "handrail_02", x:2, y:5},
        {image: "handrail_02", x:3, y:5},
        {image: "handrail_02", x:4, y:5},
        {image: "handrail_06", x:5, y:5},
        {image: "handrail_11", x:5, y:4},
        {image: "handrail_11", x:5, y:3},
        {image: "handrail_11", x:5, y:2},
        {image: "handrail_11", x:5, y:1},
        {image: "handrail_13", x:5, y:0}
    ],
    10 : [
        {image: "handrail_02", x:0, y:4},
        {image: "handrail_02", x:1, y:4},
        {image: "handrail_06", x:2, y:4},
        {image: "handrail_13", x:2, y:3},
        {image: "handrail_02", x:3, y:3},
        {image: "handrail_02", x:4, y:3},
        {image: "handrail_06", x:4, y:3},
        {image: "handrail_13", x:4, y:2},
        {image: "handrail_02", x:5, y:2},
        {image: "handrail_02", x:6, y:2}
    ],
    11: [
        {image: "guardrail_05", x:0, y:1},
        {image: "guardrail_06", x:5, y:1},
        {image: "guardrail_07", x:0, y:3},
        {image: "guardrail_08", x:5, y:3},
        {image: "guardrail_04", x:0, y:2},
        {image: "guardrail_01", x:1, y:1},
        {image: "guardrail_01", x:2, y:1},
        {image: "guardrail_01", x:3, y:1},
        {image: "guardrail_01", x:4, y:1},
        {image: "guardrail_03", x:5, y:2},
        {image: "guardrail_02", x:1, y:3},
        {image: "guardrail_02", x:2, y:3},
        {image: "guardrail_02", x:3, y:3},
        {image: "guardrail_02", x:4, y:3}
    ],
    12: [
        {image: "guardrail_05", x:0, y:0},
        {image: "guardrail_07", x:0, y:2},
        {image: "guardrail_06", x:4, y:0},
        {image: "guardrail_04", x:0, y:1},
        {image: "guardrail_03", x:4, y:1},
        {image: "guardrail_01", x:1, y:0},
        {image: "guardrail_01", x:2, y:0},
        {image: "guardrail_01", x:3, y:0},
        {image: "guardrail_02", x:1, y:2},
        {image: "guardrail_10", x:2, y:2},
        {image: "guardrail_04", x:2, y:3},
        {image: "guardrail_03", x:6, y:3},
        {image: "guardrail_11", x:4, y:2},
        {image: "guardrail_01", x:5, y:2},
        {image: "guardrail_02", x:3, y:4},
        {image: "guardrail_02", x:4, y:4},
        {image: "guardrail_02", x:5, y:4},
        {image: "guardrail_06", x:6, y:2},
        {image: "guardrail_07", x:2, y:4},
        {image: "guardrail_08", x:6, y:4}
    ],
    13: [
        {image: "guardrail_12", x:2, y:1},
        {image: "guardrail_11", x:4, y:1},
        {image: "guardrail_10", x:2, y:3},
        {image: "guardrail_09", x:4, y:3},
        {image: "guardrail_04", x:2, y:0},
        {image: "guardrail_03", x:4, y:0},
        {image: "guardrail_01", x:1, y:1},
        {image: "guardrail_02", x:1, y:3},
        {image: "guardrail_01", x:5, y:1},
        {image: "guardrail_02", x:5, y:3},
        {image: "guardrail_04", x:2, y:4},
        {image: "guardrail_03", x:4, y:4},
        {image: "guardrail_04", x:0, y:2},
        {image: "guardrail_03", x:6, y:2},
        {image: "guardrail_05", x:0, y:1},
        {image: "guardrail_07", x:0, y:3},
        {image: "guardrail_06", x:6, y:1},
        {image: "guardrail_08", x:6, y:3}
    ],
    14: [
        {image: "guardrail_01", x:0, y:1},
        {image: "guardrail_01", x:1, y:1},
        {image: "guardrail_01", x:2, y:1},
        {image: "guardrail_01", x:3, y:1},
        {image: "guardrail_01", x:4, y:1},
        {image: "guardrail_01", x:5, y:1},
        {image: "guardrail_01", x:6, y:1},
        {image: "guardrail_02", x:0, y:3},
        {image: "guardrail_02", x:1, y:3},
        {image: "guardrail_02", x:2, y:3},
        {image: "guardrail_02", x:3, y:3},
        {image: "guardrail_02", x:4, y:3},
        {image: "guardrail_02", x:5, y:3},
        {image: "guardrail_02", x:6, y:3}
    ],
    15: [
        {image: "guardrail_12", x:1, y:2},
        {image: "guardrail_12", x:3, y:1},
        {image: "guardrail_09", x:1, y:4},
        {image: "guardrail_09", x:3, y:3},
        {image: "guardrail_09", x:5, y:2},
        {image: "guardrail_01", x:0, y:2},
        {image: "guardrail_01", x:2, y:1},
        {image: "guardrail_01", x:4, y:0},
        {image: "guardrail_01", x:5, y:0},
        {image: "guardrail_01", x:6, y:0},
        {image: "guardrail_02", x:2, y:4},
        {image: "guardrail_02", x:4, y:3},
        {image: "guardrail_02", x:6, y:2},
        {image: "guardrail_05", x:1, y:1},
        {image: "guardrail_05", x:3, y:0},
        {image: "guardrail_08", x:3, y:4},
        {image: "guardrail_08", x:5, y:3}
    ],
    16: [
        {image: "guardrail_12", x:3, y:0},
        {image: "guardrail_12", x:3, y:3},
        {image: "guardrail_10", x:3, y:2},
        {image: "guardrail_11", x:5, y:3},
        {image: "guardrail_04", x:1, y:1},
        {image: "guardrail_03", x:5, y:0},
        {image: "guardrail_03", x:5, y:1},
        {image: "guardrail_03", x:5, y:2},
        {image: "guardrail_02", x:2, y:2},
        {image: "guardrail_01", x:2, y:0},
        {image: "guardrail_01", x:0, y:3},
        {image: "guardrail_01", x:1, y:3},
        {image: "guardrail_01", x:2, y:3},
        {image: "guardrail_01", x:6, y:3},
        {image: "guardrail_05", x:1, y:0},
        {image: "guardrail_07", x:1, y:2}
    ],
    17: [
        {image: "guardrail_11", x:1, y:0},
        {image: "guardrail_09", x:1, y:2},
        {image: "guardrail_09", x:5, y:2},
        {image: "guardrail_10", x:3, y:2},
        {image: "guardrail_03", x:1, y:3},
        {image: "guardrail_03", x:1, y:4},
        {image: "guardrail_03", x:5, y:3},
        {image: "guardrail_04", x:3, y:3},
        {image: "guardrail_01", x:2, y:0},
        {image: "guardrail_01", x:3, y:0},
        {image: "guardrail_01", x:4, y:0},
        {image: "guardrail_01", x:5, y:0},
        {image: "guardrail_01", x:6, y:0},
        {image: "guardrail_02", x:2, y:2},
        {image: "guardrail_02", x:6, y:2},
        {image: "guardrail_02", x:4, y:4},
        {image: "guardrail_07", x:3, y:4},
        {image: "guardrail_08", x:5, y:4}
    ],
    18: [
        // {image: "guardrail_12", x:1, y:1},
        // {image: "guardrail_13", x:3, y:1},
        // {image: "guardrail_11", x:5, y:1},
        // {image: "guardrail_10", x:1, y:3},
        // {image: "guardrail_14", x:3, y:3},
        // {image: "guardrail_09", x:4, y:3},
        // {image: "guardrail_04", x:1, y:0},
        // {image: "guardrail_04", x:1, y:4},
        // {image: "guardrail_04", x:3, y:0},
        // {image: "guardrail_04", x:3, y:4},
        // {image: "guardrail_03", x:3, y:0},
        // {image: "guardrail_03", x:3, y:4},
        // {image: "guardrail_03", x:5, y:0},
        // {image: "guardrail_03", x:4, y:4},
        // {image: "guardrail_01", x:0, y:1},
        // {image: "guardrail_01", x:6, y:1},
        // {image: "guardrail_02", x:0, y:3},
        // {image: "guardrail_02", x:6, y:3}
    ],
    19: [
        {image: "guardrail_12", x:0, y:1},
        {image: "guardrail_11", x:6, y:1},
        {image: "guardrail_10", x:0, y:3},
        {image: "guardrail_09", x:6, y:3},
        {image: "guardrail_13", x:2, y:1},
        {image: "guardrail_13", x:4, y:1},
        {image: "guardrail_14", x:2, y:3},
        {image: "guardrail_14", x:4, y:3},
        {image: "guardrail_04", x:0, y:0},
        {image: "guardrail_04", x:2, y:0},
        {image: "guardrail_04", x:4, y:0},
        {image: "guardrail_04", x:0, y:4},
        {image: "guardrail_04", x:2, y:4},
        {image: "guardrail_04", x:4, y:4},
        {image: "guardrail_03", x:2, y:0},
        {image: "guardrail_03", x:4, y:0},
        {image: "guardrail_03", x:6, y:0},
        {image: "guardrail_03", x:2, y:4},
        {image: "guardrail_03", x:4, y:4},
        {image: "guardrail_03", x:6, y:4}
    ],
    20: [
        {image: "guardrail_12", x:1, y:1},
        {image: "guardrail_10", x:1, y:3},
        {image: "guardrail_13", x:3, y:1},
        {image: "guardrail_13", x:5, y:1},
        {image: "guardrail_14", x:3, y:3},
        {image: "guardrail_14", x:5, y:3},
        {image: "guardrail_01", x:0, y:1},
        {image: "guardrail_02", x:0, y:3},
        {image: "guardrail_04", x:1, y:0},
        {image: "guardrail_04", x:3, y:0},
        {image: "guardrail_04", x:5, y:0},
        {image: "guardrail_04", x:1, y:4},
        {image: "guardrail_04", x:3, y:4},
        {image: "guardrail_04", x:5, y:4},
        {image: "guardrail_03", x:3, y:0},
        {image: "guardrail_03", x:5, y:0},
        {image: "guardrail_03", x:3, y:4},
        {image: "guardrail_03", x:5, y:4}
    ]


}

CPartyData.obstacle = {
    2: [
        {image: "obstacle_02", x:3, y:1, type: Ntry.STATIC.OBSTACLE_ELECTRIC},
        {image: "obstacle_02", x:5, y:1, type: Ntry.STATIC.OBSTACLE_ELECTRIC}
    ],
    4: [
        {image: "obstacle_02", x:3, y:2, type: Ntry.STATIC.OBSTACLE_ELECTRIC}
    ],
    5: [
        {image: "obstacle_01", x:4, y:2, type: Ntry.STATIC.OBSTACLE_ELECTRIC},
        {image: "obstacle_02", x:3, y:3, type: Ntry.STATIC.OBSTACLE_ELECTRIC}
    ],
    6: [
        {image: "handrail_02", x:0, y:2},
        {image: "handrail_02", x:1, y:2},
        {image: "handrail_02", x:2, y:2},
        {image: "handrail_02", x:3, y:2},
        {image: "handrail_02", x:4, y:2},
        {image: "handrail_02", x:5, y:2},
        {image: "handrail_02", x:6, y:2}
    ],
    7: [
        {image: "obstacle_02", x:2, y:2, type: Ntry.STATIC.OBSTACLE_ELECTRIC},
        {image: "obstacle_02", x:5, y:2, type: Ntry.STATIC.OBSTACLE_ELECTRIC}
    ],
    10: [
        {image: "obstacle_02", x:1, y:4, type: Ntry.STATIC.OBSTACLE_ELECTRIC},
        {image: "obstacle_02", x:3, y:3, type: Ntry.STATIC.OBSTACLE_ELECTRIC},
        {image: "obstacle_02", x:5, y:2, type: Ntry.STATIC.OBSTACLE_ELECTRIC}
    ],
    11: [
        {image: 'wall_deco1', x:0, y:3, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:1, y:4, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:5, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:6, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:5, y:3, type: Ntry.STATIC.OBSTACLE_BEE}
    ],
    12: [
        {image: 'wall_deco2', x:2, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:5, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:1, y:3, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:1, y:4, type: Ntry.STATIC.OBSTACLE_BEE}
    ],
    13: [
        {image: 'wall_deco2', x:0, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:6, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:1, y:4, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'obstacle_slow', x:3, y:2, type: Ntry.STATIC.OBSTACLE_SLOW}
    ],
    14: [
        {image: 'wall_deco2', x:5, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:6, y:1, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:0, y:3, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:4, y:3, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:1, y:4, type: Ntry.STATIC.OBSTACLE_BEE}
    ],
    15: [
        {image: 'wall_deco1', x:2, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:5, y:4, type: Ntry.STATIC.OBSTACLE_BEE}
    ],
    16: [
        {image: 'wall_deco2', x:1, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco2', x:6, y:0, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:1, y:2, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'wall_deco1', x:6, y:2, type: Ntry.STATIC.OBSTACLE_BEE},
        {image: 'construction', x:5, y:4, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'construction', x:4, y:0, type: Ntry.STATIC.OBSTACLE_REPAIR}
    ],
    17: [
        {image: 'wall_deco2', x:2, y:3, type: Ntry.STATIC.OBSTACLE_BANANA},
        {image: 'wall_deco1', x:5, y:4, type: Ntry.STATIC.OBSTACLE_BANANA},
        {image: 'construction', x:5, y:1, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'construction', x:0, y:0, type: Ntry.STATIC.OBSTACLE_REPAIR}
    ],
    18: [
        {image: 'wall_deco2', x:6, y:4, type: Ntry.STATIC.OBSTACLE_BANANA},
        {image: 'obstacle_slow', x:2, y:2, type: Ntry.STATIC.OBSTACLE_SLOW},
        {image: 'obstacle_slow', x:5, y:2, type: Ntry.STATIC.OBSTACLE_SLOW}
    ],
    19: [
        {image: 'construction', x:1, y:1, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'construction', x:6, y:2, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'obstacle_slow', x:3, y:2, type: Ntry.STATIC.OBSTACLE_SLOW}
    ],
    20: [
        {image: 'wall_deco2', x:0, y:4, type: Ntry.STATIC.OBSTACLE_BANANA},
        {image: 'construction', x:1, y:2, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'construction', x:6, y:1, type: Ntry.STATIC.OBSTACLE_REPAIR},
        {image: 'obstacle_slow', x:3, y:2, type: Ntry.STATIC.OBSTACLE_SLOW}
    ]
};

CPartyData.START = {
    type: "jr_start_basic",
    x: 50,
    y: 30,
    movable: false,
    deletable: false,
    readOnly: true
};

CPartyData.player = {
    1: {
        x: 3,
        y: 2,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="32" x="20" y="22" movable="false" deletable="false"><next><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="36" deletable="false"></block></next></block></xml>'
    },
    2: {
        x: 1,
        y: 1,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"><next><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="32" deletable="false"><next><block type="maze_step_unjump" class="inline maze_step_unjump" id="35" deletable="false"></block></next></block></next></block></xml>'
    },
    3: {
        x: 1,
        y: 2,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    4: {
        x: 2,
        y: 3,
        direction: Ntry.STATIC.NORTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    5: {
        x: 1,
        y: 3,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    6: {
        x: 0,
        y: 2,
        direction: Ntry.STATIC.EAST,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"><next><block type="maze_step_unfor" class="inline maze_step_unfor" id="34" inline="true" deletable="false"><field name="VALUE">2</field><statement name="DO"><block type="maze_step_move_unstep" class="inline maze_step_move_unstep" id="37" deletable="false"></block></statement></block></next></block></xml>'
    },
    7: {
        x: 0,
        y: 2,
        direction: Ntry.STATIC.EAST,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    8: {
        x: 4,
        y: 1,
        direction: Ntry.STATIC.SOUTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="31" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    9: {
        x: 1,
        y: 5,
        direction: Ntry.STATIC.SOUTH,
        script: '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="17" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    10: {
        x: 0,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        script:  '<xml><block type="maze_step_unstart" class="inline maze_step_unstart" id="17" x="20" y="22" movable="false" deletable="false"></block></xml>'
    },
    11: {
        x: 1,
        y: 2,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START,
                {type: "jr_go_straight"}
            ]
        ]
    },
    12: {
        x: 1,
        y: 1,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    13: {
        x: 1,
        y: 2,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    14: {
        x: 0,
        y: 2,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    15: {
        x: 0,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    16: {
        x: 0,
        y: 4,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START,
                {type: "jr_repeat_until_dest",
                    values: {
                        "STATEMENT": [
                            {type: "jr_go_straight"},
                            {type: "jr_if_construction"}
                        ]
                    }
                }
            ]
        ]
    },
    17: {
        x: 0,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    18: {
        x: 0,
        y: 2,
        direction: Ntry.STATIC.EAST,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    19: {
        x: 1,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    20: {
        x: 6,
        y: 4,
        direction: Ntry.STATIC.NORTH,
        code: [
            [
                CPartyData.START
            ]
        ]
    },
    21: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="13" x="20" y="27" movable="false" deletable="false"><next><block type="ai_move_right_un" class="inline ai_move_right_un" id="15" deletable="false"><next><block type="ai_move_right_un" class="inline ai_move_right_un" id="17" deletable="false"><next><block type="ai_move_right_un" class="inline ai_move_right_un" id="19" deletable="false"></block></next></block></next></block></next></block></xml>'
    },
    22: {
        x: 0,
        y: 2,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="13" x="20" y="27" movable="false" deletable="false"></block></xml>'
    },
    23: {
        x: 0,
        y: 2,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="7" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="9" deletable="false"></block></next></block></xml>'
    },
    24: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="7" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="9" deletable="false"></block></next></block></xml>'
    },
    25: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="19" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="20" deletable="false"><statement name="STACK"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="21" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="26"></block></value><statement name="STACK_IF"><block type="ai_move_right_un" class="inline ai_move_right_un" id="24" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_move_up_un" class="inline ai_move_up_un" id="25" deletable="false"></block></statement></block></statement></block></next></block></xml>'
    },
    26: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="21" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="22" deletable="false"><statement name="STACK"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="23" inline="true" deletable="false"><value name="BOOL"><block type="ai_boolean_distance_un" class="output ai_boolean_distance_un" id="24" inline="true" deletable="false"><field name="DIRECTION">RIGHT</field><field name="OPERATOR">BIGGER</field><value name="DATA"><block type="number_un" class="output number_un" id="25"><field name="NUM">1</field></block></value></block></value><statement name="STACK_IF"><block type="ai_move_right_un" class="inline ai_move_right_un" id="26" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="27" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="32"></block></value></block></statement></block></statement></block></next></block></xml>'
    },
    27: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="51" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="52" deletable="false"></block></next></block></xml>'
    },
    28: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="15" deletable="false" movable="false" x="20" y="27"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="17" deletable="false"><statement name="STACK"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="19" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="21"></block></value><statement name="STACK_IF"><block type="ai_move_up_un" class="inline ai_move_up_un" id="23" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="25" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="21"></block></value><statement name="STACK_IF"><block type="ai_move_right_un" class="inline ai_move_right_un" id="29" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="31" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="33"></block></value><statement name="STACK_IF"><block type="ai_move_down_un" class="inline ai_move_down_un" id="35" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_move_right_un" class="inline ai_move_right_un" id="37" deletable="false"></block></statement></block></statement></block></statement></block></statement></block></next></block></xml>'
    },
    29: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="17" deletable="false" movable="false" x="20" y="27"><next><block type="ai_move_right_un" class="inline ai_move_right_un" id="18" deletable="false"><next><block type="ai_move_right_un" class="inline ai_move_right_un" id="19" deletable="false"><next><block type="ai_use_item_un" class="inline ai_use_item_un" id="20" deletable="false"><next><block type="ai_repeat_until_reach_un" class="inline ai_repeat_until_reach_un" id="21" deletable="false"><statement name="STACK"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="22" inline="true" deletable="false"><value name="BOOL"><block type="ai_boolean_object_un" class="output ai_boolean_object_un" id="23" deletable="false"><field name="DIRECTION">RIGHT</field><field name="OBJECT">ITEM</field></block></value><statement name="STACK_IF"><block type="ai_move_right_un" class="inline ai_move_right_un" id="31" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="25" inline="true" deletable="false"><value name="BOOL"><block type="True_un" class="output True_un" id="71"></block></value><statement name="STACK_IF"><block type="ai_move_down_un" class="inline ai_move_down_un" id="33" deletable="false"></block></statement><statement name="STACK_ELSE"><block type="ai_if_else_2_un" class="inline ai_if_else_2_un" id="35" inline="true" deletable="false"><value name="BOOL"><block type="ai_boolean_object_un" class="output ai_boolean_object_un" id="36" deletable="false"><field name="DIRECTION">UP</field><field name="OBJECT">ITEM</field></block></value><statement name="STACK_ELSE"><block type="ai_use_item_un" class="inline ai_use_item_un" id="28" deletable="false"></block></statement></block></statement></block></statement></block></statement></block></next></block></next></block></next></block></next></block></xml>'
    },
    30: {
        x: 0,
        y: 1,
        script: '<xml><block type="ai_start_un" class="inline ai_start_un" id="7" deletable="false" movable="false" x="20" y="27"></block></xml>'
    }
};

CPartyData.goal = {
    1: [
        {image: "goal", x:6, y:2}
    ],
    2: [
        {image: "goal", x:6, y:1}
    ],
    3: [
        {image: "goal", x:3, y:1}
    ],
    4: [
        {image: "goal", x:4, y:3}
    ],
    5: [
        {image: "goal", x:5, y:1},
    ],
    6: [
        {image: "goal", x:6, y:2},
    ],
    7: [
        {image: "goal", x:6, y:2}
    ],
    8: [
        {image: "goal", x:2, y:1}
    ],
    9: [
        {image: "goal", x:1, y:1}
    ],
    10: [
        {image: "goal", x:6, y:1}
    ],
    11: [
        {image: "goal", x:4, y:2}
    ],
    12: [
        {image: "goal", x:5, y:3}
    ],
    13: [
        {image: "goal", x:5, y:2}
    ],
    14: [
        {image: "goal", x:6, y:2}
    ],
    15: [
        {image: "goal", x:6, y:1}
    ],
    16: [
        {image: "goal", x:2, y:1}
    ],
    17: [
        {image: "goal", x:4, y:3}
    ],
    18: [
        {image: "goal", x:6, y:2}
    ],
    19: [
        {image: "goal", x:5, y:4}
    ],
    20: [
        {image: "goal", x:2, y:0}
    ]
};

CPartyData.space_map = {
    21: [
         [0, 0, 0, 0, 0],
         [0, 0, 0, 0, 1],
         [0, 0, 0, 0, 0]
    ],
    22: [
         [0, 0, 0, 1, 1, 1, 0],
         [0, 0, 1, 0, 1, 0, 1],
         [0, 1, 1, 1, 0, 1, 1]
    ],
    23: [
         [0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1],
         [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
         [0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0]
    ],
    24: [
         [0, 1, 1, 1, 1, 1],
         [0, 0, 0, 0, 1, 0],
         [0, 0, 0, 0, 0, 0]
    ],
    25: [
         [0, 0, 0, 0, 0, 0],
         [0, 0, 0, 0, 1, 0],
         [0, 1, 1, 1, 1, 1]
    ],
    26: [
         [0, 1, 0, 0, 1, 1],
         [0, 0, 0, 1, 0, 1],
         [0, 1, 1, 1, 0, 0]
    ],
    27: [
         [0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1],
         [0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0],
         [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0]
    ],
    28: [
         [0, 0, 1, 1, 1, 0, 2, 0, 1, 0],
         [0, 0, 1, 0, 2, 0, 1, 0, 2, 0],
         [0, 0, 2, 0, 1, 1, 1, 1, 1, 0]
    ],
    29: [
         [0, 0, 0, 1, 0, 0, 1, 0, 0, 1],
         [0, 0, 2, 1, 0, 0, 1, 0, 2, 1],
         [0, 0, 0, 1, 0, 2, 1, 0, 0, 1]
    ]
};

CPartyData.help = {
};


CPartyData.FRAMES = {};
CPartyData.FRAMES[Ntry.STATIC.STAND] = {
    north: {key: 2, frame: [0]},
    east:  {key: 1, frame: [0]},
    south: {key: 0, frame: [0]},
    west:  {key: 1, frame: [0], flip: true},
    next: Ntry.STATIC.STAND,
    movement: 0
};
CPartyData.FRAMES[Ntry.STATIC.WALK] = {
    north: {key: 2, frame: _.range(0, 15)},
    east:  {key: 1, frame: _.range(0, 16)},
    south: {key: 0, frame: _.range(0, 15)},
    west:  {key: 1, frame: _.range(0, 16), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 1,
    gridMovement: 1
};
CPartyData.FRAMES[Ntry.STATIC.JUMP] = {
    north: {key: 14, frame: _.range(0, 11)},
    east:  {key: 12, frame: _.range(0, 14)},
    south: {key: 13, frame: _.range(0, 11)},
    west:  {key: 12, frame: _.range(0, 14), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 2,
    gridMovement: 2
};
CPartyData.FRAMES[Ntry.STATIC.TURN_RIGHT] = {
    north: {key: 15, frame: [4, 3, 2]},
    east:  {key: 15, frame: [2, 1, 0]},
    south: {key: 15, frame: [8, 7, 6]},
    west:  {key: 15, frame: [6, 5, 4]},
    next: Ntry.STATIC.STAND,
    rotation: 1,
    movement: 0
};
CPartyData.FRAMES[Ntry.STATIC.TURN_LEFT] = {
    north: {key: 15, frame: [4, 5, 6]},
    east:  {key: 15, frame: [2, 3, 4]},
    south: {key: 15, frame: [8, 0, 1]},
    west:  {key: 15, frame: [6, 7, 8]},
    next: Ntry.STATIC.STAND,
    rotation: -1,
    movement: 0
};
var simoorookFrame = new Array(8).join('0').split('').concat(_.range(0, 7));
CPartyData.FRAMES[Ntry.STATIC.SIMOOROOK] = {
    north: {key: 5, frame: simoorookFrame},
    east:  {key: 4, frame: simoorookFrame},
    south: {key: 3, frame: simoorookFrame},
    west:  {key: 4, frame: simoorookFrame, flip: true},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
CPartyData.FRAMES[Ntry.STATIC.WALL_CRASH] = {
    north: {key: 8, frame: _.range(0, 12)},
    east:  {key: 6, frame: _.range(0, 11)},
    south: {key: 7, frame: _.range(0, 12)},
    west:  {key: 6, frame: _.range(0, 11), flip: true},
    next: Ntry.STATIC.FAIL,
    movement: -0.3
};
CPartyData.FRAMES[Ntry.STATIC.BEE_ATTACK] = {
    north: {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    east : {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    south: {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    west : {key: 10, frame: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
CPartyData.FRAMES[Ntry.STATIC.ELECTRIC_SHOCK] = {
    north: {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    east:  {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    south: {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    west:  {key: 9, frame: [0, 1, 0, 1, 0, 1, 0, 1, 2]},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
CPartyData.FRAMES[Ntry.STATIC.SLIP] = {
    north: {key: 11, frame: _.range(0, 6)},
    east:  {key: 11, frame: _.range(0, 6)},
    south: {key: 11, frame: _.range(0, 6)},
    west:  {key: 11, frame: _.range(0, 6)},
    next: Ntry.STATIC.FAIL,
    movement: 0.5
};
CPartyData.FRAMES[Ntry.STATIC.STOP] = {};

CPartyData.CAR_FRAMES = {};
CPartyData.CAR_FRAMES[Ntry.STATIC.STAND] = {
    north: {key: 5, frame: [0]},
    east:  {key: 6, frame: [0]},
    south: {key: 0, frame: [0]},
    west:  {key: 6, frame: [0], flip: true},
    next: Ntry.STATIC.STAND,
    movement: 0
};
CPartyData.CAR_FRAMES[Ntry.STATIC.WALK] = {
    north: {key: 5, frame: _.range(0, 4)},
    east:  {key: 6, frame: _.range(0, 4)},
    south: {key: 4, frame: _.range(0, 4)},
    west:  {key: 6, frame: _.range(0, 4), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 1,
    gridMovement: 1
};
CPartyData.CAR_FRAMES[Ntry.STATIC.JUMP] = {
    north: {key: 5, frame: _.range(0, 9)},
    east:  {key: 6, frame: _.range(0, 9)},
    south: {key: 4, frame: _.range(0, 9)},
    west:  {key: 6, frame: _.range(0, 9), flip: true},
    next: Ntry.STATIC.STAND,
    movement: 2,
    gridMovement: 2
};
CPartyData.CAR_FRAMES[Ntry.STATIC.TURN_RIGHT] = {
    north: {key: 0, frame: [4, 3, 2]},
    east:  {key: 0, frame: [2, 1, 0]},
    south: {key: 0, frame: [0, 7, 6]},
    west:  {key: 0, frame: [6, 5, 4]},
    next: Ntry.STATIC.STAND,
    rotation: 1,
    movement: 0
};
CPartyData.CAR_FRAMES[Ntry.STATIC.TURN_LEFT] = {
    north: {key: 0, frame: [4, 5, 6]},
    east:  {key: 0, frame: [2, 3, 4]},
    south: {key: 0, frame: [0, 1, 2]},
    west:  {key: 0, frame: [6, 7, 0]},
    next: Ntry.STATIC.STAND,
    rotation: -1,
    movement: 0
};
//var simoorookFrame = new Array(8).join('0').split('').concat(_.range(0, 7));
CPartyData.CAR_FRAMES[Ntry.STATIC.SIMOOROOK] = {
    north: {key: 8, frame: _.range(0, 7)},
    east:  {key: 9, frame: _.range(0, 6)},
    south: {key: 7, frame: _.range(0, 7)},
    west:  {key: 9, frame: _.range(0, 6), flip: true},
    next: Ntry.STATIC.FAIL,
    movement: 0
};
CPartyData.CAR_FRAMES[Ntry.STATIC.WALL_CRASH] = {
    north: {key: 2, frame: _.range(0, 12)},
    east:  {key: 3, frame: _.range(0, 12)},
    south: {key: 1, frame: _.range(0, 12)},
    west:  {key: 3, frame: _.range(0, 12), flip: true},
    next: Ntry.STATIC.FAIL,
    movement: -0.3
};

CPartyData.CAR_FRAMES[Ntry.STATIC.GO_SLOW_CRASH] = {
    north: {key: 2, frame: _.range(0, 11)},
    east:  {key: 3, frame: _.range(0, 11)},
    south: {key: 1, frame: _.range(0, 11)},
    west:  {key: 3, frame: _.range(0, 11), flip: true},
    next: Ntry.STATIC.FAIL,
    movement: -0.3
};


(function(slowArray){
    CPartyData.CAR_FRAMES[Ntry.STATIC.GO_SLOW] = {
        north: {key: 5, frame: slowArray},
        east:  {key: 6, frame: slowArray},
        south: {key: 4, frame: slowArray},
        west:  {key: 6, frame: slowArray, flip: true},
        next: Ntry.STATIC.STAND,
        movement: 2,
        gridMovement: 2
    };
})(_.range(0,8).concat(_.range(0,8)).concat(_.range(0,8)));


CPartyData.CAR_FRAMES[Ntry.STATIC.STOP] = {};

